export default "__VITE_ASSET__97f77cf9__"